<template>
    <div class="createRdv">
        <Header :code="code">{{this.projet.nom}}</Header>
        <div class="searchInput">
            <v-text-field
                prepend-inner-icon="mdi-magnify"
                v-model="searchText"
                hide-details
                label="Rechercher un lead (nom, prénom ou code)"
                @input="filterLeads"
            ></v-text-field>
        </div>
        <v-container>
            <v-row dense v-if="!createNewLead">
                <v-col cols="12" class="text-center" v-if='!searched'>
                    <p>Pour créer un rendez-vous, rechercher un lead pour lui attribuer.</p>
                    <p>Si aucun lead n'est trouvé, vous pourrez en créer un nouveau.</p>
                </v-col>
                <v-col cols="12" class="text-center" v-if="searched">
                    <p v-if='leads.length > 0'>Sélectionnez un lead :</p>
                    <v-card elevation="0" rounded v-for="lead in this.leads" :key="lead.id" class="cardLead" @click="$router.push({name: 'AddRdv', params: {code: code, idLead: lead.id, mode: 'create'}})">
                        <v-card-title class="title">
                            {{lead.prenom}} {{lead.nom}}
                        </v-card-title>
                        <v-card-subtitle class="sub">
                            <span>{{lead.code_lead}} 
                            <span v-if="lead.telephone_mobile == ''"> {{lead.telephone_fixe}}</span>
                            <span v-if="lead.telephone_mobile != ''"> {{lead.telephone_mobile}}</span></span>
                            <span class="status" v-if="lead.finalStatut">{{$t('messages.statuts.'+lead.finalStatut)}}</span>
                        </v-card-subtitle>
                        <i class="mdi mdi-plus-circle"></i>
                    </v-card>
                    <p v-if='leads.length > 0'>Ou créez en un nouveau :</p>
                    <p v-if="leads.length == 0">Pas de résultats, créez un nouveau lead pour lui attribuer un rdv</p>
                    <v-btn depressed color="primary" rounded @click="createNewLead = !createNewLead">Nouveau Lead</v-btn>
                </v-col>
            </v-row>
            <v-row dense v-if="createNewLead">
                <LeadForm :lead="leadToCreate" @recordLead="createLead" @cancelForm="createNewLead = !createNewLead"/>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import Header from '@/components/Header'
import LeadForm from '@/components/LeadForm'
export default {
    name: 'CreateRdv',
    props: ['code'],
    components: {
        Header,
        LeadForm
    },
    data() {
        return {
            projet: {},
            leads: {},
            searchText: '',
            searched: false,
            createNewLead: false,
            leadToCreate: {
                civilite: "",
                nom: "",
                prenom : "",
                telephone_mobile : "",
                telephone_fixe : "",
                email: "",
                langue_preferee: "",
                adresse: {
                    rue1 : "",
                    rue2 : "",
                    code_postal: "",
                    ville: ""
                },
                commentaire: ""
            }
        }
    },
    methods: {
        createLead(user){
            let leadToCreate = {};
            leadToCreate.code_projet = this.code;
            leadToCreate.id_utilisateur = this.$store.state.user.id
            leadToCreate.data = {
                civilite : user.civilite,
                nom: user.nom,
                prenom: user.prenom,
                email: user.email,
                telephone_mobile: user.telephone_mobile,
                telephone_fixe: user.telephone_fixe,
                telephone_pro: user.telephone_pro,
                rue1: user.adresse.rue1,
                rue2: user.adresse.rue2,
                code_postal: user.adresse.code_postal,
                ville: user.adresse.ville,
                commentaire: user.commentaire,
                source: "WEBAPP",
                autorisation_RGPD_pour_projet: "OUI",
                autorisation_RGPD_pour_autres_projets: "NON",
                source_autorisations: "WEBAPP",
                langue_preferee: user.langue_preferee,
                id_utilisateur: this.$store.state.user.id
            }
            this.$store.dispatch('setLoader', true).then((e)=> {
                this.$store.dispatch('createLead', leadToCreate).then((e)=> {
                    this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=>{
                        this.$router.push({name: 'AddRdv', params: {code: this.code, idLead: this.$store.state.createdLeadId, mode: 'create'}})
                    })
                })
            })
        },
        filterLeads(){
            if(this.searchText.length > 2){
                //recherche
                this.leads = this.$store.getters.searchNewLeads(this.searchText);
                this.searched = true;
            } else {
                this.leads = {};
                this.searched = false;
            }
        },
        status(finalStatut) {
            switch (finalStatut) {
                case "echec":
                    return this.$t('messages.statuts.echec')
                    break;
                case "passage":
                    return this.$t('messages.statuts.passage')
                break;
                case "rdvQualifier":
                    return this.$t('messages.statuts.rdvQualifier')
                break;
                case "rdvaQualifier":
                    return this.$t('messages.statuts.rdvaQualifier')
                break;
                case "nouveau":
                    return this.$t('messages.statuts.nouveau')
                break;
                case "rdvaConfirmer":
                    return this.$t('messages.statuts.rdvaConfirmer')
                break;
                case "ARLP":
                    return this.$t('messages.statuts.ARLP')
                break;
                case "ARRP":
                    return this.$t('messages.statuts.ARRP')
                break;
                case "wait":
                    return this.$t('messages.statuts.wait')
                break;
            }
        },
    },
    computed: {
        
    },
    created() {
        
        if(this.$store.state.loader){
            this.$store.dispatch('setLoader', false)
        }
        this.projet = this.$store.state.projets.find((e) => {
            return e.code_projet == this.code
        })
    },
}
</script>
<style lang="scss">
    .createRdv {
        padding-top: 18vh;
        .searchInput {
            position:fixed;
            width:100%;
            top:8vh;
            z-index:6;
            height: 10vh;
            padding:10px 30px;
            padding-bottom:15px;
            background-color: white;
            border-bottom:1px solid #eb566b;
            .v-input {
                font-size:1em;
                margin-top:0;
            }
            label {
                font-size: 14px;
            }
            p {
                margin-bottom:5px;
            }
        }
        .cardLead {
            margin-bottom:10px;
            i {
                font-size:1.4em;
                position:absolute;
                right:10px;
                top:50%;
                transform:translateY(-50%);
            }
        }
        .title{
            font-size:1em !important;
            letter-spacing:-1px !important;
            font-weight:700;
            line-height: unset !important;
        }
        .sub {
            width:85%;
            display:flex;
            align-items: center;
            justify-content: space-between;
            .status {
                padding:5px;
                background-color: orange;
                color:#FFF;
                border-radius:3px;
                font-size:0.9em;
                margin-left:20px;
                line-height: 1em;
            }
        }
    }
</style>